import cx from 'classnames';
import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import type { ITooltip } from 'react-tooltip';

import s from './tooltip.module.css';

export type TooltipProps = ITooltip;

const Tooltip = (props: TooltipProps) => (
    <ReactTooltip {...props} className={cx(s.tooltip, props.className)} />
);

Tooltip.displayName = 'Tooltip';

export default Tooltip;
